export const Games: any = {
    "four": {
        "four-1": {
            id: 'four-1',
            startState: '.b.. r... b..b ...b'
        },
        "four-2": {
            id: 'four-2',
            startState: 'rr.. .r.b .... ..r.'
        },
        "four-3": {
            id: 'four-3',
            startState: '.... r..r r.b. ...b'
        },
        "four-4": {
            id: 'four-4',
            startState: '..rr .... ...b .br.'
        },
        "four-5": {
            id: 'four-5',
            startState: '..rb ...b ..r. .r..'
        },
        "four-6": {
            id: 'four-6',
            startState: '..bb ..b. .... r...'
        },
        "four-7": {
            id: 'four-7',
            startState: '..rr .b.. ...r ....'
        }
    },
    "six": {
        "six-1": {
            id: 'six-1',
            startState: '...b.. r.b... r..b.. .r.... .....b r.rb.b'
        },
        "six-2": {
            id: 'six-2',
            startState: '.....r ...... bb..b. ...r.. .r.... br.rb.'
        }
    },
    "eight": {
        "eight-1": {
            id: 'eight-1',
            startState: 'br...... ...b.b.. .r.....r b.b...rr ...b.... b.....rr ...b.... .b.b....'
        },
        "eight-2": {
            id: 'eight-2',
            startState: '.....r.. r..r.rb. .r..r.b. br...... ....rr.. .r....rr b....... rr...b..'
        },
        "eight-3": {
            id: 'eight-3',
            startState: 'b....... ........ ..rr.b.r ......b. .r..r... ...b..b. .r.bb... ...rb..b'
        }
    },
    "ten": {
        "ten-1": {
            id: 'ten-1',
            startState: '......b... ..r.b..rr. r..b.r..r. r......... .......b.r .r..b..b.. ..br.r.... b.......r. ..b....... ..r...b.rr'
        }
    }
}